<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h3>網站報名聯繫</h3>
          <h4>逢甲大學地理資訊系統研究中心</h4>
          <ul>
            <li>
              李小姐<span class="icon icon-phone mx-1"></span
              >0424516669分機704<a href="mailto:bellalee@gis.tw"
                ><span class="icon icon-mail mx-1"></span>bellalee@gis.tw</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <h3>行政單位窗口</h3>
          <h4>國家高速網路與計算中心</h4>
          <ul>
            <li>
              林小姐<span class="icon icon-phone mx-1"></span
              >03-5776085分機339<a href="mailto:2103063@narlabs.org.tw"
                ><span class="icon icon-mail mx-1"></span
                >2103063@narlabs.org.tw</a
              >
            </li>
            <li>
              常先生<span class="icon icon-phone mx-1"></span
              >03-5776085分機386<a href="mailto:stoca@narlabs.org.tw"
                ><span class="icon icon-mail mx-1"></span
                >stoca@narlabs.org.tw</a
              >
            </li>
          </ul>
        </div>
      </div>

      <hr class="bg-light" />

      <div class="organizer">
        <div class="row">
          <div class="col-lg-3">
            <h4>指導單位</h4>
            <ul>
              <li>
                <img src="imgs/logo_MIROC.png" class="img-fluid" alt="內政部" />
              </li>
            </ul>
          </div>
          <div class="col-lg-5">
            <h4>主辦單位</h4>
            <ul>
              <li>
                <img
                  src="imgs/logo_NCHC.png"
                  class="img-fluid"
                  alt="財團法人國家實驗研究院國家高速網路與計算中心"
                />
              </li>
            </ul>
          </div>
        </div>

        <h4>執行單位</h4>
        <ul class="row">
          <!-- <li class="col-md-3">
            <img
              src="imgs/tgic_logo.png"
              class="img-fluid"
              alt="財團法人台灣地理資訊中心"
            />
          </li> -->
          <li class="col-md-3">
            <img
              src="imgs/logo_GIS.png"
              class="img-fluid"
              alt="逢甲大學地理資訊系統研究中心"
            />
          </li>
          <li class="col-md-3">
            <img
              src="imgs/logo_EasyMap.png"
              class="img-fluid"
              alt="易圖科技股份有限公司"
            />
          </li>
          <li class="col-md-3">
            <img
              src="imgs/logo_Geosense.png"
              class="img-fluid"
              alt="天思數位科技股份有限公司"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
};
</script>